module.exports = __webpack_public_path__ + "img/p7.47a8b09b.svg";